import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Drawer as DrawerCreate } from '@mui/material';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { CreateUsersCard } from 'entities/users/ui/CreateUsersCard';

export const UsersDrawer = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  return (
    <DrawerCreate
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <CreateUsersCard />
      </DrawerContent>
    </DrawerCreate>
  );
};
